/*
    © Copyright LinkHMS B.V. All rights reserved.
    * Proprietary and confidential.
    * Unauthorized copying of this file, via any medium is strictly prohibited.
*/

import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { I18nService } from '@core/services/i18n.service';

import { MetaService } from './meta.service';

export const metaGuard = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  const url = state.url;
  const meta = inject(MetaService);
  const I18n = inject(I18nService);
  const metaSettings = route.hasOwnProperty('data') ? route.data['meta'] : undefined;

  I18n.currentLanguage$.subscribe(() => {
    meta.update(url, metaSettings);
  });
  return true;
};
